const supportedLocales = [
  'fr-CA',
  'fr-FR',
  'en-US',
  'de-DE',
  'it-IT',
  'nl-NL',
  'es-ES'
].map(l => l.toLocaleLowerCase());

export function mapUnsupportedLanguage(locale: string) {
  const initialLocale = locale.toLocaleLowerCase();

  if (supportedLocales.includes(initialLocale)) {
    return locale;
  }

  const map = {
    'nl-be': 'nl-NL',
    'fr-be': 'fr-FR'
  };

  return map[initialLocale] || 'en-US';
}
